import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { AppState_getInstance33x03n2an9aul as AppState_getInstance } from '../../../../../kiteui-library/com/lightningkite/kiteui/reactive/AppState.js.mjs';
import { get_stringsy7vodl9dj0ya as get_strings } from '../strings.mjs';
import { get_sessionTokenxwi299b0ks21 as get_sessionToken } from '../sdk/currentSession.mjs';
import { get_pageNavigatorp3to6r4j8ctv as get_pageNavigator } from '../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Navigator.mjs';
import { HomePage3ptt6l367zajb as HomePage } from './HomeScreen.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { orPromise1iucc2to2udt2 as orPromise } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import {
  constructCallableReference23y65rf941mch as constructCallableReference,
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import {
  Signal1973xs1vkmdcb as Signal,
  _Constant___init__impl__v45mub2qfk15kh5l39c as _Constant___init__impl__v45mub,
  Constant3smypj7m9af27 as Constant,
} from '../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { PrimitiveClasses_getInstance13wbaztpz3e2d as PrimitiveClasses_getInstance } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/primitives.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { serializer1hwzc6m64v1op as serializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/Serializers.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { PersistentProperty2s7ex88zm8bn9 as PersistentProperty } from '../../../../../kiteui-library/com/lightningkite/kiteui/reactive/PersistentProperty.mjs';
import { remember2m0mx1b5ra75q as remember } from '../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import {
  get_selectedApi2lg32khtf3h6e as get_selectedApi,
  get_entrieswc88194blsbo as get_entries,
} from '../sdk/apiOptions.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { mapOf2zpbbmyqk8xpf as mapOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { AuthEndpoints35rits72n531v as AuthEndpoints } from '../../../../../lightning-server-kiteui-client/com/lightningkite/lightningserver/auth/authInterfaces.mjs';
import { AuthComponenthdtropyf0pe3 as AuthComponent } from '../../../../../lightning-server-kiteui-client/com/lightningkite/kiteui/auth/authComponent.mjs';
import { Frame1e7t2kcdb3wu7 as Frame } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Frame.commonHtml.mjs';
import { ensureOutermostElement1f4fzdv7yw0ql as ensureOutermostElement } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/NativeElement.mjs';
import { reactive2xic0rufq5s8n as reactive } from '../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import { get_centered31th09q7x90sf as get_centered } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { get_rem2p56fiaxda5jo as get_rem } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import {
  SizeConstraints24axz83pb17aw as SizeConstraints,
  ImageScaleType_Fit_getInstance3ce22z7h47ouq as ImageScaleType_Fit_getInstance,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import {
  sizedBox3aolxerximlpj as sizedBox,
  shownWhen3t7othivfr11 as shownWhen,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import {
  get_scrolling3fwkltztkpfe8 as get_scrolling,
  sizeConstraints19w9rda6g3rqz as sizeConstraints,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import { RowOrCol3a33s3yce2tuv as RowOrCol } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/LinearLayouts.commonHtml.mjs';
import { Resources_getInstance22dnzrm1gxkf3 as Resources_getInstance } from '../Resources.js.mjs';
import { RawImageView3rlp4gsc2bxt0 as RawImageView } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/RawImageView.commonHtml.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import {
  TextView$_get_content_$ref_4pzcwl5a4gnldk8ef9 as TextView$_get_content_$ref_4pzcwl,
  TextView$_set_content_$ref_pketfb11e282hr0m0jl as TextView$_set_content_$ref_pketfb,
  FullscreenPage2qcc83o0veqoh as FullscreenPage,
} from '../App.mjs';
import { LabeledViewseav57tyecmf as LabeledView } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/labels.mjs';
import { FieldSemantic_getInstancer1p3l15xmphu as FieldSemantic_getInstance } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { themed2vu67ornd4jps as themed } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import { Select2osqjs95yxuh6 as Select } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Select.commonHtml.mjs';
import { toList3jhuyej2anx2q as toList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { errorText83fzxqvlxz6i as errorText } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/shortstuff.mjs';
import { Page1o437w9xuocrm as Page } from '../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Page.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        this.SECRET_FOR_API_SELECTOR_1 = '84321';
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
function LoginPage$_get_title_$lambda_ohpfcy($this$remember) {
  return $this$remember.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_loginPageTitle_1ofql3_k$();
}
function LoginPage$render$lambda$slambda($this_render) {
  return constructCallableReference((token, $completion) => orPromise($completion, function *($completion) {
    yield* get_sessionToken().set_revjhg_k$(token, $completion);
    get_pageNavigator($this_render.get_context_h02k06_k$()).reset_diztr_k$(new (HomePage())());
    return Unit_instance;
  }), 1);
}
function LoginPage$render$lambda($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_loginPrompt_y6r4qs_k$();
}
function LabeledView$_get_content_$ref_5yojet(p0) {
  return constructCallableReference(() => p0.get_content_h02jrk_k$(), 0, 0, 128, VOID, [p0]);
}
function LabeledView$_set_content_$ref_ys1c8f(p0) {
  return constructCallableReference((p0_0) => {
    p0.set_content_lzqutq_k$(p0_0);
    return Unit_instance;
  }, 1, 0, 129, VOID, [p0]);
}
function LoginPage$render$lambda_0($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_loginServerFieldLabel_24y76r_k$();
}
function LoginPage$render$lambda_1(it) {
  return it.apiName_1;
}
var LoginPageClass;
function LoginPage() {
  if (LoginPageClass === VOID) {
    class $ {
      constructor() {
        this.email_1 = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$('');
        var tmp = this;
        // Inline function 'com.lightningkite.kiteui.reactive.PersistentProperty' call
        var key = 'backendSelectorEnabled';
        // Inline function 'kotlinx.serialization.serializer' call
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_0 = serializer(createKType(PrimitiveClasses_getInstance().get_booleanClass_d285fr_k$(), arrayOf([]), false));
        var tmp$ret$1 = isInterface(this_0, KSerializer()) ? this_0 : THROW_CCE();
        tmp.backendSelectorEnabled_1 = PersistentProperty().new_com_lightningkite_kiteui_reactive_PersistentProperty_dblk10_k$(key, false, tmp$ret$1);
      }
      get_title_iz32un_k$() {
        return remember(VOID, VOID, VOID, VOID, LoginPage$_get_title_$lambda_ohpfcy);
      }
      render_w3x9d1_k$(_this__u8e3s4) {
        var authUI = remember(VOID, VOID, VOID, VOID, ($this$remember) => {
          var api = $this$remember.invoke_r7m7el_k$(get_selectedApi()).get_api_18j9e7_k$();
          var tmp = new (AuthEndpoints())(mapOf(to('User', api.userAuth_1)), VOID, VOID, api.userAuth_1.email_1);
          var anon = new (AuthComponent())(tmp, VOID, api.userAuth_1, VOID, VOID, VOID, LoginPage$render$lambda$slambda(_this__u8e3s4));
          anon.rawPrimaryInput_1.set_value_v1vabv_k$(this.email_1.get_value_j01efc_k$());
          return anon;
        });
        // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element = new (Frame())(_this__u8e3s4.get_context_h02k06_k$());
        ensureOutermostElement(element);
        _this__u8e3s4.willAddChild_hz2iwc_k$(element);
        reactive(element, VOID, ($this$reactive) => {
          var tmp;
          var tmp0_safe_receiver = $this$reactive.invoke_r7m7el_k$($this$reactive.invoke_r7m7el_k$(authUI).primaryIdentifier_1);
          if ((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.value_1) === '84321') {
            this.backendSelectorEnabled_1.set_value_v1vabv_k$(true);
            tmp = Unit_instance;
          }
          return Unit_instance;
        });
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_0 = get_scrolling(sizedBox(get_centered(element), new (SizeConstraints())(VOID, get_rem(40))));
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_0 = new (RowOrCol())(this_0.get_context_h02k06_k$());
        ensureOutermostElement(element_0);
        this_0.willAddChild_hz2iwc_k$(element_0);
        element_0.set_vertical_nuap32_k$(true);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_1 = get_centered(element_0);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_1 = new (RowOrCol())(this_1.get_context_h02k06_k$());
        ensureOutermostElement(element_1);
        this_1.willAddChild_hz2iwc_k$(element_1);
        element_1.set_vertical_nuap32_k$(true);
        var tmp0 = sizeConstraints(get_centered(element_1), VOID, VOID, VOID, VOID, VOID, get_rem(20));
        var tmp2 = Resources_getInstance().logoHorizontal_1;
        // Inline function 'com.lightningkite.kiteui.views.direct.rawImage' call
        var description = 'The Community Group';
        var scaleType = ImageScaleType_Fit_getInstance();
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_2 = new (RawImageView())(tmp0.get_context_h02k06_k$(), tmp2, description, scaleType);
        ensureOutermostElement(element_2);
        tmp0.willAddChild_hz2iwc_k$(element_2);
        element_2.onStartup_vrxh3i_k$();
        tmp0.addChild_2qpft2_k$(element_2);
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        var this_2 = get_centered(element_1);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_3 = new (TextView())(this_2.get_context_h02k06_k$());
        ensureOutermostElement(element_3);
        this_2.willAddChild_hz2iwc_k$(element_3);
        var tmp = KMutableProperty0();
        var tmp_0 = TextView$_get_content_$ref_4pzcwl(element_3);
        var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element_3));
        element_3.invoke_bnq13k_k$(tmp_1, LoginPage$render$lambda);
        element_3.onStartup_vrxh3i_k$();
        this_2.addChild_2qpft2_k$(element_3);
        element_1.onStartup_vrxh3i_k$();
        this_1.addChild_2qpft2_k$(element_1);
        // Inline function 'com.lightningkite.kiteui.views.l2.label' call
        var this_3 = shownWhen(element_0, VOID, VOID, ($this$shownWhen) => $this$shownWhen.invoke_r7m7el_k$(this.backendSelectorEnabled_1));
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_4 = LabeledView().new_com_lightningkite_kiteui_views_l2_LabeledView_y9e4ty_k$(this_3.get_context_h02k06_k$());
        ensureOutermostElement(element_4);
        this_3.willAddChild_hz2iwc_k$(element_4);
        var tmp_2 = KMutableProperty0();
        var tmp_3 = LabeledView$_get_content_$ref_5yojet(element_4);
        var tmp_4 = getPropertyCallableRef('content', 0, tmp_2, tmp_3, LabeledView$_set_content_$ref_ys1c8f(element_4));
        element_4.invoke_bnq13k_k$(tmp_4, LoginPage$render$lambda_0);
        // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
        // Inline function 'com.lightningkite.kiteui.views.direct.select' call
        var this_4 = themed(element_4, FieldSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_5 = new (Select())(this_4.get_context_h02k06_k$());
        ensureOutermostElement(element_5);
        this_4.willAddChild_hz2iwc_k$(element_5);
        var tmp_5 = get_selectedApi();
        // Inline function 'kotlin.let' call
        var p0 = toList(get_entries());
        var tmp_6 = _Constant___init__impl__v45mub(p0);
        element_5.bind_64a41i_k$(tmp_5, new (Constant())(tmp_6), LoginPage$render$lambda_1);
        element_5.onStartup_vrxh3i_k$();
        this_4.addChild_2qpft2_k$(element_5);
        errorText(element_4);
        element_4.onStartup_vrxh3i_k$();
        this_3.addChild_2qpft2_k$(element_4);
        // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_6 = new (Frame())(element_0.get_context_h02k06_k$());
        ensureOutermostElement(element_6);
        element_0.willAddChild_hz2iwc_k$(element_6);
        var $this$auth = element_6;
        reactive($this$auth, VOID, ($this$reactive) => {
          $this$auth.clearChildren_eufjq4_k$();
          $this$reactive.invoke_r7m7el_k$(authUI).render_8j8w82_k$($this$auth);
          return Unit_instance;
        });
        element_6.onStartup_vrxh3i_k$();
        element_0.addChild_2qpft2_k$(element_6);
        element_0.onStartup_vrxh3i_k$();
        this_0.addChild_2qpft2_k$(element_0);
        element.onStartup_vrxh3i_k$();
        _this__u8e3s4.addChild_2qpft2_k$(element);
      }
    }
    initMetadataForClass($, 'LoginPage', LoginPage, VOID, [Page(), FullscreenPage()]);
    LoginPageClass = $;
  }
  return LoginPageClass;
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  LabeledView$_get_content_$ref_5yojet as LabeledView$_get_content_$ref_5yojet1mvh3jfqyuzca,
  LabeledView$_set_content_$ref_ys1c8f as LabeledView$_set_content_$ref_ys1c8fi8j7ehqqddvg,
  LoginPage as LoginPage29d8dob2fd0ln,
};
//endregion

//# sourceMappingURL=LoginScreen.mjs.map
